export const keys = {
  accept: 'accept',
  apiKey: 'x-api-key',
  auth: 'authorization',
  csrf: 'x-csrf-token',
  ctype: 'content-type',
  lang: 'accept-language',
};

export const values = {
  html: 'text/html',
  json: 'application/json',
};
